import {reduxName} from './constants'

export const INITIALIZE: string = reduxName + '/INITIALIZE';
export const SET: string = reduxName + '/SET';
export const SET_COLOR: string = reduxName + '/SET_COLOR';
export const SET_LIGHT_BOX: string = reduxName + '/SET_LIGHT_BOX';